import script from "./crossSale.vue?vue&type=script&setup=true&lang=ts"
export * from "./crossSale.vue?vue&type=script&setup=true&lang=ts"

import "./crossSale.vue?vue&type=style&index=0&id=cd8cae10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd8cae10"]])

export default __exports__